(function () {
  'use strict';
  if (window.SIFableRefBundle) {
    window.SIFableRefBundle.initAll(document);
    return;
  }
  window.SIFableRefBundle = {
    initAll: function (scope) {
      var roots = [];
      if (scope && scope.matches && scope.matches('[data-siw-root]')) roots.push(scope);
      if (scope && scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll('[data-siw-root]')));
      roots.forEach(function (root) { window.SIFableRefBundle.init(root); });
    },
    init: function (root) {
      if (root.dataset.siwReady === 'true') return;
      root.dataset.siwReady = 'true';
      var controller = new AbortController();
      var signal = controller.signal;
      var viewObserver = null, observer = null;
      var barResizeObserver = null;
      var currentStep = 1;
      var planner = null;
      // Map keyed by variant ID: selecting different variants of the same product is supported.
      var stickers = new Map();
      var accessories = new Map();
      var busy = false;
      var cartAdded = false;
      var plannerAdvanceTimer = null;
      var maxStickers = Math.max(1, Number(root.dataset.maxStickers) || 8);
      var minAccessories = Math.max(0, Number(root.dataset.minAccessories) || 0);
      var maxAccessories = Math.max(1, Number(root.dataset.maxAccessories) || 10);
      if (minAccessories > maxAccessories) minAccessories = maxAccessories;
      var showPricePreview = root.dataset.showPricePreview === 'true';
      var showSavings = root.dataset.showSavings === 'true' || showPricePreview;
      var autoMatchCover = root.dataset.autoCoverMatch !== 'false';
      var matchedCoverVariantId = '';
      var matchedCoverProductId = '';
      var discountTiers = [root.dataset.discountTierOne, root.dataset.discountTierTwo, root.dataset.discountTierThree]
        .map(function (rate) { return Math.max(0, Math.min(100, Number(rate) || 0)); });
      // The gift comes from the merchant's Shopify product picker, never from a shopper selection.
      var giftMode = root.dataset.topTierFreeGift === 'true';
      var gift = {};
      try {
        var giftNode = root.querySelector('[data-siw-gift]');
        if (giftNode) gift = JSON.parse(giftNode.textContent) || {};
      } catch (giftError) { gift = {}; }
      var giftReady = giftMode && gift.available === true && Number(gift.variantId) > 0;
      if (giftMode) discountTiers[2] = discountTiers[1];
      var currency = root.dataset.currency || 'USD';
      var siwVersion = root.dataset.version || 'V26';
      var restoreMinutes = Math.max(0, Number(root.dataset.restoreMinutes) || 0);
      var useDataLayer = root.dataset.pushDatalayer === 'true';
      var lastTier = null;
      var showAddedNotice = false;
      var restoring = false;
      var builderViewedSent = false;
      // Messages come from theme editor settings (JSON blob rendered by Liquid).
      // A blank setting falls back to these defaults so the UI never shows an empty message.
      var siwCopyDefaults = {
        needBoth: 'Add 2 items to start saving',
        needPlanner: 'Add 1 planner to start saving',
        needSet: 'Add 1 set to start saving {tier1}%',
        tier1: 'You’re saving {tier1}%! Only 1 set away from saving {tier2}%',
        tier2: 'You’re saving {tier2}%! Only 1 set away from saving {tier3}%',
        tier3: 'You’re saving {tier3}%! Maximum welcome savings',
        previewPrefix: 'Offer preview ·'
      };
      var siwCopy = {};
      (function () {
        var parsed = {};
        try {
          var node = root.querySelector('[data-siw-copy]');
          if (node) parsed = JSON.parse(node.textContent) || {};
        } catch (copyError) { parsed = {}; }
        Object.keys(siwCopyDefaults).forEach(function (key) {
          var value = parsed[key];
          siwCopy[key] = value != null && String(value).trim() !== '' ? String(value) : siwCopyDefaults[key];
        });
      })();
      function siwFmt(message) {
        return String(message || '')
          .replace(/\{tier1\}/g, discountTiers[0])
          .replace(/\{tier2\}/g, discountTiers[1])
          .replace(/\{tier3\}/g, discountTiers[2])
          .replace(/\{min\}/g, minAccessories);
      }
      // Publishes to Shopify web pixels (Shopify.analytics.publish) and, if enabled in
      // the section settings, mirrors each event to window.dataLayer. Never throws.
      function siwTrack(name, data) {
        try {
          if (window.Shopify && window.Shopify.designMode) return;
          var payload = Object.assign({ kit_version: siwVersion, page_path: window.location.pathname }, data || {});
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            var result = window.Shopify.analytics.publish('welcome_kit:' + name, payload);
            if (result && typeof result.catch === 'function') result.catch(function () {});
          }
          if (useDataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: 'welcome_kit_' + name }, payload));
          }
        } catch (trackError) { /* tracking must never affect the shopper */ }
      }
      var locale = document.documentElement.lang || 'en-US';
      var bar = root.querySelector('[data-siw-mobile-bar]');
      // Portaling avoids position:fixed being trapped by Focal's transformed or clipped containers.
      var previousBar = document.getElementById('siw-fixed-bar-' + root.dataset.sectionId);
      if (previousBar && previousBar !== bar) previousBar.remove();
      if (bar && document.body && bar.parentElement !== document.body) document.body.appendChild(bar);
      var fableInline = root.querySelector('[data-siw-fable-bar]');
      var fableAnchor = root.querySelector('[data-siw-fable-anchor]');
      // Move the SAME bar to body, never clone it. The anchor keeps its original
      // space in the page, and the bar's fixed top follows that anchor until it
      // reaches the configured header offset. No fade/swap = no flashing.
      var fableFixed = fableInline;
      if (fableFixed && fableAnchor && document.body) {
        var originalBarHeight = fableFixed.getBoundingClientRect().height;
        fableAnchor.style.height = originalBarHeight + 'px';
        fableFixed.id = 'siw-fable-fixed-' + root.dataset.sectionId;
        fableFixed.classList.add('siw__fable-bar--fixed');
        var rootStyles = getComputedStyle(root);
        ['--siw-bg', '--siw-text', '--siw-muted', '--siw-line', '--siw-accent',
         '--siw-fable-top', '--siw-fable-bg', '--siw-fable-fill'].forEach(function (name) {
          fableFixed.style.setProperty(name, rootStyles.getPropertyValue(name).trim());
        });
        fableFixed.style.fontFamily = rootStyles.fontFamily;
        document.body.appendChild(fableFixed);
      }
      var fableBars = [fableFixed].filter(Boolean);
      var fableScrim = null;
      var fableSummary = root.querySelector('.siw__summary');
      // Native <dialog> stays in its section. showModal() puts it in the browser's
      // top layer, so transforms/overflow on the Focal theme cannot clip it.
      var fableDrawerOpen = false;
      var rebuyCartOpen = false;
      var qs = function (selector) {
        return root.querySelector(selector)
          || (fableSummary && (fableSummary.matches(selector) ? fableSummary : fableSummary.querySelector(selector)))
          || (bar && (bar.matches(selector) ? bar : bar.querySelector(selector)));
      };
      var qsa = function (selector) {
        return Array.from(root.querySelectorAll(selector));
      };
      var formatPrice = function (cents) {
        try {
          return new Intl.NumberFormat(locale, {
            style:'currency', currency:currency, currencyDisplay:'narrowSymbol',
            minimumFractionDigits:Math.abs(Math.round(cents)) % 100 === 0 ? 0 : 2,
            maximumFractionDigits:2
          }).format(cents / 100);
        } catch (error) {
          var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
          return currency === 'USD' ? '$' + amount : amount + ' ' + currency;
        }
      };
      // Covers are identified both by their name/handle and by the exact product
      // referenced in the planners' custom.clear_cover_match variant metafields.
      // This also supports cover products that have been renamed.
      var referencedCoverProductIds = new Set();
      qsa('[data-step="1"][data-siw-product]').forEach(function (card) {
        if (card.dataset.clearCoverProductId) referencedCoverProductIds.add(String(card.dataset.clearCoverProductId));
      });
      var clearCoverCards = [];
      var clearCoverProductIds = new Set();
      function mountStepProducts(step) {
        var container = root.querySelector('[data-siw-step-content="' + step + '"]');
        if (!container) return;
        var template = container.querySelector('template[data-siw-lazy-catalog]');
        if (!template) return;
        template.replaceWith(template.content.cloneNode(true));
        if (step === 3) indexClearCovers();
      }
      function indexClearCovers() {
        var grid = root.querySelector('[data-siw-panel="3-accessories"] .siw__products');
        if (!grid) {
          var panel = root.querySelector('[data-siw-panel="3-accessories"]');
          if (panel) { grid = document.createElement('div'); grid.className = 'siw__products'; panel.prepend(grid); }
        }
        // Cards inside the accessories collection are optional convenience only.
        // Explicit planner metafield references always get their own fallback card.
        if (grid) root.querySelectorAll('[data-siw-cover-template]').forEach(function (template) {
          var id = template.dataset.siwCoverVariant;
          var inGrid = Array.from(grid.querySelectorAll('[data-siw-product]')).some(function (card) {
            return Array.from(card.querySelectorAll('option')).some(function (option) { return option.value === id; });
          });
          if (!inGrid && !grid.querySelector('[data-siw-explicit-cover-variant="' + id + '"]')) {
            var clone = template.content.cloneNode(true);
            var card = clone.querySelector('[data-siw-product]');
            if (card) { card.dataset.siwExplicitCoverVariant = id; grid.prepend(clone); }
          }
        });
        var referencedVariants = new Set(Array.from(root.querySelectorAll('[data-siw-cover-template]')).map(function (tpl) {
          return tpl.dataset.siwCoverVariant;
        }));
        clearCoverCards = qsa('[data-step="3"][data-siw-product]').filter(function (card) {
          var select = card.querySelector('[data-siw-variant]');
          var isCover = card.dataset.siwClearCoverProduct === 'true' ||
            referencedCoverProductIds.has(String(card.dataset.productId)) ||
            (select && Array.from(select.options).some(function (option) { return referencedVariants.has(option.value); }));
          if (isCover) { card.dataset.siwLockedClearCover = 'true'; card.hidden = true; }
          return isCover;
        });
        clearCoverProductIds = new Set(clearCoverCards.map(function (card) { return String(card.dataset.productId); }));
      }
      function isClearCoverCard(card) { return !!card && card.dataset.siwLockedClearCover === 'true'; }
      function selectionFromCard(card) {
        if (!card) return null;
        var select = card.querySelector('[data-siw-variant]');
        var option = select && select.options[select.selectedIndex];
        if (!option || !option.value || option.disabled) return null;
        // A hidden selector or programmatic select change may never substitute a
        // different cover size, even when that variant exists and is in stock.
        if (isClearCoverCard(card) && (!matchedCoverVariantId ||
            String(card.dataset.productId) !== matchedCoverProductId ||
            String(option.value) !== matchedCoverVariantId)) return null;
        return {
          productId: String(card.dataset.productId),
          clearCoverVariantId: option.dataset.clearCoverVariantId || card.dataset.clearCoverVariantId || '',
          clearCoverAvailable: (option.dataset.clearCoverVariantId ? option.dataset.clearCoverAvailable : card.dataset.clearCoverAvailable) === 'true',
          variantId: String(option.value),
          title: card.dataset.title || '',
          variantTitle: option.textContent.replace(/\s*— Sold out$/, '').trim(),
          price: Number(option.dataset.price || 0),
          image: option.dataset.image || card.dataset.productImage || '',
          qty: 1
        };
      }
      function refreshOptionUI(card) {
        var select = card.querySelector('[data-siw-variant]');
        if (!select) return;
        if (isClearCoverCard(card)) {
          // Display ONLY the selected size/cover-type options, as read-only pills.
          // Do not expose a way to choose an incompatible size/cover type.
          var coverGroup = card.querySelector('[data-siw-option-groups]');
          var lockedOption = select.options[select.selectedIndex];
          var validMatch = !!lockedOption && !lockedOption.disabled &&
            String(card.dataset.productId) === matchedCoverProductId &&
            String(lockedOption.value) === matchedCoverVariantId;
          if (coverGroup) coverGroup.hidden = !validMatch;
          card.querySelectorAll('[data-siw-option-group]').forEach(function (fieldset) {
            var pos = fieldset.dataset.siwOptionGroup;
            var selectedValue = validMatch ? lockedOption.dataset['option' + pos] : '';
            fieldset.hidden = !selectedValue;
            var selectedLabel = fieldset.querySelector('[data-siw-selected-option]');
            if (selectedLabel) selectedLabel.textContent = selectedValue;
            fieldset.querySelectorAll('[data-siw-option]').forEach(function (button) {
              var matching = !!selectedValue && button.dataset.siwOptionValue === selectedValue;
              button.hidden = !matching;
              button.classList.toggle('is-active', matching);
              if (matching) {
                // Even if Shopify's option was a color swatch, a cover's locked
                // option should be shown as a legible selected text pill.
                button.classList.remove('is-swatch');
                button.classList.add('is-pill','is-edge-pill','is-locked-cover-option');
                button.textContent = selectedValue;
              }
              button.disabled = !matching;
              button.setAttribute('aria-pressed', matching ? 'true' : 'false');
              if (matching) button.setAttribute('aria-disabled','true');
            });
          });
          return;
        }
        var chosen = select.options[select.selectedIndex];
        var variants = Array.from(select.options).filter(function (variant) { return variant.value && !variant.disabled; });
        card.querySelectorAll('[data-siw-option]').forEach(function (button) {
          var position = button.dataset.siwOptionPosition;
          var value = button.dataset.siwOptionValue;
          var active = !!chosen && chosen.dataset['option' + position] === value;
          var possible = variants.some(function (variant) { return variant.dataset['option' + position] === value; });
          button.classList.toggle('is-active', active);
          button.classList.toggle('is-unavailable', !possible);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          button.disabled = busy || !possible;
        });
        card.querySelectorAll('[data-siw-selected-option]').forEach(function (label) {
          var position = label.dataset.siwSelectedOption;
          label.textContent = chosen ? (chosen.dataset['option' + position] || '') : '';
        });
      }
      function refreshCardVariant(card) {
        var entry = selectionFromCard(card);
        if (!entry) return;
        var priceNode = card.querySelector('[data-siw-price]');
        if (priceNode) priceNode.textContent = formatPrice(entry.price);
        var select = card.querySelector('[data-siw-variant]');
        var selected = select && select.options[select.selectedIndex];
        var image = card.querySelector('.siw__product-image');
        if (image && selected && selected.dataset.cardImage) {
          image.src = selected.dataset.cardImage;
          image.removeAttribute('srcset');
        }
        refreshOptionUI(card);
      }
      // Restrict all clear-cover cards to ONLY the exact variant referenced by
      // the chosen planner. No match / missing or sold-out reference => no cover.
      // Preserve the customer's chosen cover quantity when changing planners,
      // but never keep an incompatible variant in the bundle.
      function syncClearCoverMatch() {
        var desiredId = autoMatchCover && planner ? String(planner.clearCoverVariantId || '') : '';
        var matchedCard = null;
        var matchedOption = null;
        if (desiredId) {
          clearCoverCards.some(function (card) {
            var select = card.querySelector('[data-siw-variant]');
            var option = select && Array.from(select.options).find(function (item) {
              return String(item.value) === desiredId && !item.disabled;
            });
            if (!option) return false;
            matchedCard = card;
            matchedOption = option;
            return true;
          });
        }
        // Remove old cover sizes before applying the new match. Other accessory
        // products (and quantities) are untouched.
        var previouslyChosenQty = 0;
        Array.from(accessories.entries()).forEach(function (pair) {
          var entry = pair[1];
          if (clearCoverProductIds.has(String(entry.productId))) {
            previouslyChosenQty += Number(entry.qty) || 0;
            accessories.delete(pair[0]);
          }
        });
        matchedCoverVariantId = matchedCard ? desiredId : '';
        matchedCoverProductId = matchedCard ? String(matchedCard.dataset.productId) : '';
        if (matchedCard && matchedOption) {
          var select = matchedCard.querySelector('[data-siw-variant]');
          select.value = desiredId;
          refreshCardVariant(matchedCard);
          if (previouslyChosenQty > 0) {
            var choice = selectionFromCard(matchedCard);
            if (choice) {
              var usedByOtherAccessories = Array.from(accessories.values()).reduce(function (n, entry) { return n + entry.qty; }, 0);
              choice.qty = Math.min(previouslyChosenQty, Math.max(0, maxAccessories - usedByOtherAccessories));
              if (choice.qty) accessories.set(desiredId, choice);
            }
          }
        }
        clearCoverCards.forEach(function (card) {
          var isMatch = card === matchedCard;
          // Unmatched/sold-out/missing-match covers should not be offered at all.
          // The valid matching cover is first in the accessory grid.
          card.hidden = !isMatch;
          card.classList.toggle('is-cover-available', isMatch);
          var message = card.querySelector('[data-siw-cover-lock-description]');
          if (message) message.hidden = true;
          refreshOptionUI(card);
        });
        var coverUnavailable = qs('[data-siw-cover-unavailable]');
        if (coverUnavailable) coverUnavailable.hidden = !desiredId || !!matchedCard || !planner || !planner.clearCoverAvailable || !clearCoverCards.length;
        // If Shopify reports the referenced variant as sold out, always show the notice.
        if (coverUnavailable && desiredId && planner && planner.clearCoverAvailable === false) coverUnavailable.hidden = false;
        var notice = qs('[data-siw-cover-notice]');
        if (notice) {
          notice.hidden = !matchedCard;
          var details = qs('[data-siw-cover-notice-details]');
          if (details) details.textContent = matchedCard ? (matchedCard.dataset.title + ' · ' + matchedOption.textContent.trim()) : '';
        }
      }
      function totalQuantity(map) {
        return Array.from(map.values()).reduce(function (count, entry) { return count + entry.qty; }, 0);
      }
      function coverSelectionsValid() {
        return Array.from(accessories.values()).every(function (entry) {
          return !clearCoverProductIds.has(String(entry.productId)) ||
            (matchedCoverVariantId && String(entry.variantId) === matchedCoverVariantId &&
             String(entry.productId) === matchedCoverProductId);
        });
      }
      function kitReady() { return !!planner && totalQuantity(stickers) >= 1 &&
        totalQuantity(accessories) >= minAccessories && coverSelectionsValid(); }
      // Optional extras are not automatically shown as a completed step.
      // Cart eligibility is intentionally handled separately by kitReady().
      function completed() { return [!!planner, totalQuantity(stickers) >= 1,
        totalQuantity(accessories) >= (minAccessories || 1)]; }
      function getActiveEntry(card) {
        var chosen = selectionFromCard(card);
        if (!chosen) return null;
        var step = Number(card.dataset.step);
        if (step === 1) return planner && planner.variantId === chosen.variantId ? planner : null;
        return (step === 2 ? stickers : accessories).get(chosen.variantId) || null;
      }
      function updateQuantity(card, change) {
        if (busy) return;
        var selection = selectionFromCard(card);
        if (!selection) return;
        var step = Number(card.dataset.step);
        if (step === 1) {
          planner = selection;
          syncClearCoverMatch();
          render();
          // Let the choice visibly register, then guide the shopper into Step 2.
          // No artificial wait for people who prefer reduced motion.
          if (plannerAdvanceTimer) window.clearTimeout(plannerAdvanceTimer);
          var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (prefersReducedMotion) { showStep(2); return; }
          var chooseLabel = card.querySelector('[data-siw-choose-text]');
          if (chooseLabel) chooseLabel.textContent = '✓ Added to your kit';
          plannerAdvanceTimer = window.setTimeout(function () {
            plannerAdvanceTimer = null;
            showStep(2);
          }, 520);
          return;
        }
        var map = step === 2 ? stickers : accessories;
        var limit = step === 2 ? maxStickers : maxAccessories;
        var existing = map.get(selection.variantId);
        var oldQty = existing ? existing.qty : 0;
        var nextQty = Math.max(0, oldQty + change);
        if (change > 0 && totalQuantity(map) >= limit) return;
        if (nextQty === 0) map.delete(selection.variantId);
        else { selection.qty = nextQty; map.set(selection.variantId, selection); }
        render();
      }
      var drawerOpener = null;
      function toggleFableDrawer(open) {
        if (!fableSummary) return;
        if (open && !fableSummary.open) {
          drawerOpener = document.activeElement;
          try { fableSummary.showModal(); } catch (err) { return; }
          var close = fableSummary.querySelector('[data-siw-fable-close]');
          if (close) close.focus({ preventScroll:true });
        } else if (!open && fableSummary.open) {
          fableSummary.close();
        }
        fableDrawerOpen = fableSummary.open;
        fableBars.forEach(function (item) {
          var toggle = item.querySelector('[data-siw-fable-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', String(fableDrawerOpen));
        });
        if (!fableDrawerOpen && drawerOpener && drawerOpener.isConnected &&
            typeof drawerOpener.focus === 'function') drawerOpener.focus({ preventScroll:true });
      }
      var fablePinQueued = false;
      var cachedTopSetting = parseFloat(getComputedStyle(root).getPropertyValue('--siw-fable-top')) || 0;
      // Mobile: catch the savings bar at the *actual* lower edge of the Focal
      // header. The theme-editor offset may be a little too tall on phones,
      // leaving a visible strip of the catalog between the header and the bar.
      // Desktop continues to use the merchant's configured offset unchanged.
      var headerSelector = '#shopify-section-header, .shopify-section--header, [id^="shopify-section-sections--"][id$="__header"], sticky-header';
      var mobileHeader = document.querySelector(headerSelector);
      function fableCatchTop() {
        if (window.innerWidth > 760) return cachedTopSetting;
        if (!mobileHeader || !mobileHeader.isConnected) mobileHeader = document.querySelector(headerSelector);
        if (!mobileHeader) return cachedTopSetting;
        var headerRect = mobileHeader.getBoundingClientRect();
        if (!Number.isFinite(headerRect.bottom)) return cachedTopSetting;
        // If the header scrolls away rather than sticking, let the bar meet
        // the viewport top. A partially visible header is handled as well.
        return Math.max(0, Math.round(headerRect.bottom));
      }
      var cachedFableHeight = fableFixed ? fableFixed.getBoundingClientRect().height : 0;
      // The inline bar is much taller on mobile because it initially includes
      // thumbnails and actions. After portaling, the fixed savings bar only
      // shows the compact progress meter. Reserve the FIXED bar's actual height,
      // not the original pre-portal height, or a large empty gap is left behind.
      if (fableAnchor && fableFixed) {
        fableAnchor.style.height = Math.ceil(cachedFableHeight) + 'px';
      }
      var reference = root.querySelector('.siw__intro') || root.querySelector('.siw__shell');
      function scheduleFablePin() {
        if (fablePinQueued) return;
        fablePinQueued = true;
        window.requestAnimationFrame(function () { fablePinQueued = false; updateFablePin(); });
      }
      function updateFablePin() {
        if (!fableFixed || !fableAnchor || !root.isConnected) return;
        // V8: This is the SAME bar, portaled outside Focal's transformed wrappers.
        // It follows its in-page anchor and gradually grows toward the viewport
        // edges during the last part of its approach to the sticky header.
        var topSetting = fableCatchTop();
        var anchorTop = fableAnchor.getBoundingClientRect().top;
        // Mobile CTA stays out of the way while the progress meter is still
        // moving into position. Reveal it once that meter catches the header.
        // The section IntersectionObserver separately controls whether the
        // CTA is visible at all, including at the end of the builder.
        if (bar) {
          var smallScreen = window.matchMedia('(max-width: 760px)').matches;
          bar.classList.toggle('siw__mobile-bar--engaged', !smallScreen || anchorTop <= topSetting + 2);
        }
        var distanceToCatch = anchorTop - topSetting;
        var expandDistance = 180; // px before the bar catches the header.
        var linearProgress = Math.max(0, Math.min(1, (expandDistance - distanceToCatch) / expandDistance));
        // A smoothstep easing avoids a visible size jump when expansion starts
        // or when the bar first touches the header. Works in both directions.
        var progress = linearProgress * linearProgress * (3 - 2 * linearProgress);
        var viewportWidth = document.documentElement.clientWidth || window.innerWidth;
        if (reference) {
          var rect = reference.getBoundingClientRect();
          var insetLeft = Math.max(0, Math.min(rect.left, viewportWidth - 1));
          var insetRight = Math.max(0, Math.min(viewportWidth - rect.right, viewportWidth - 1));
          var left = insetLeft * (1 - progress);
          var right = insetRight * (1 - progress);
          fableFixed.style.left = left + 'px';
          fableFixed.style.width = Math.max(1, viewportWidth - left - right) + 'px';
          fableFixed.style.borderRadius = (8 * (1 - progress)) + 'px';
        }
        // Give the bar one continuous location in document flow. Changes in its
        // responsive height are mirrored by the invisible anchor, not by a swap.
        var height = cachedFableHeight;
        var catalog = root.querySelector('.siw__catalog');
        if (catalog) catalog.style.scrollMarginTop = (topSetting + height + 16) + 'px';
        var sectionBottom = root.getBoundingClientRect().bottom;
        var top = Math.min(Math.max(anchorTop, topSetting), sectionBottom - height);
        fableFixed.style.top = top + 'px';
        fableFixed.classList.toggle('is-hidden', fableDrawerOpen || cartAdded || rebuyCartOpen);
      }
      function renderFableBar(all, subtotal, estimatedTotal, rate, reachedTier, stickerQty, pricePreviewActive) {
        // Planner alone advances halfway to 10% on the visual meter, but
        // real savings unlock only with the first sticker packet.
        // The 10/15/20% milestones occupy equal thirds of the bar.
        var message = savingsMessage(stickerQty, reachedTier);
        var pct = reachedTier >= 3 ? 100 : reachedTier === 2 ? 66.666667 : reachedTier === 1 ? 33.333333 : planner ? 16.666667 : 0;
        fableBars.forEach(function (item) {
          var subtotalLabel = item.querySelector('[data-siw-fable-subtotal]');
          if (subtotalLabel) subtotalLabel.textContent = formatPrice(subtotal);
          var msg = item.querySelector('[data-siw-fable-message]'); if (msg) msg.textContent = message;
          var fill = item.querySelector('[data-siw-fable-fill]'); if (fill) fill.style.width = pct + '%';
          item.querySelectorAll('[data-siw-fable-tier]').forEach(function (tier) { tier.classList.toggle('is-reached', Number(tier.dataset.siwFableTier) <= reachedTier); });
          var picks = item.querySelector('[data-siw-fable-picks]');
          if (picks) {
            var previousCount = Number(picks.dataset.thumbCount || 0);
            var previousScroll = picks.scrollLeft;
            var count = 0;
            var nodes = document.createDocumentFragment();
            // One thumbnail per selected VARIANT. Multiple copies of that variant
            // share one image and get a quantity badge (Fable-style). Different
            // colors/sizes remain separate so shoppers can still distinguish them.
            all.forEach(function (entry) {
              var quantity = Math.max(0, Number(entry.qty) || 0);
              if (!quantity) return;
              var thumb = document.createElement('span');
              thumb.className = 'siw__fable-thumb';
              thumb.title = entry.title +
                (entry.variantTitle && entry.variantTitle !== 'Default Title' ? ' · ' + entry.variantTitle : '') +
                ' · Qty ' + quantity;
              thumb.setAttribute('aria-label', thumb.title);
              if (entry.image) {
                var img = document.createElement('img');
                img.src = entry.image;
                img.alt = '';
                img.loading = 'lazy';
                thumb.appendChild(img);
              }
              // Each selected planner, set, or accessory can be removed here.
              // Automatic free gifts are controlled by the tier, not removable.
              if (!entry.isFreeGift) {
                var entryStep = planner === entry ? 1 : stickers.has(entry.variantId) ? 2 : accessories.has(entry.variantId) ? 3 : 0;
                if (entryStep) {
                  thumb.classList.add('has-remove');
                  var removeThumb = document.createElement('button');
                  removeThumb.type = 'button';
                  removeThumb.className = 'siw__fable-thumb-remove';
                  removeThumb.dataset.siwRemoveThumb = String(entryStep);
                  removeThumb.dataset.siwVariantId = String(entry.variantId);
                  removeThumb.textContent = '×';
                  removeThumb.title = 'Remove ' + entry.title + ' from kit';
                  removeThumb.setAttribute('aria-label', removeThumb.title);
                  thumb.appendChild(removeThumb);
                }
              }
              if (quantity > 1) {
                var badge = document.createElement('em');
                badge.className = 'siw__fable-thumb-qty';
                badge.textContent = String(quantity);
                badge.setAttribute('aria-hidden', 'true');
                thumb.appendChild(badge);
              }
              if (entry.isFreeGift === true) {
                var freeLabel = document.createElement('span');
                freeLabel.className = 'siw__fable-thumb-free';
                freeLabel.textContent = 'FREE';
                freeLabel.setAttribute('aria-hidden', 'true');
                thumb.appendChild(freeLabel);
              }
              nodes.appendChild(thumb);
              count++;
            });
            if (!count) {
              var empty = document.createElement('span');
              empty.className = 'siw__fable-empty';
              empty.textContent = '+';
              nodes.appendChild(empty);
            }
            picks.replaceChildren(nodes);
            picks.dataset.thumbCount = String(count);
            if (count > previousCount) picks.scrollLeft = picks.scrollWidth;
            else picks.scrollLeft = previousScroll;
            var mobileThumbs = qs('[data-siw-mobile-thumbs]');
            if (mobileThumbs) mobileThumbs.replaceChildren.apply(mobileThumbs,
              Array.from(picks.children).filter(function (node) { return node.classList.contains('siw__fable-thumb'); })
                .map(function (node) { return node.cloneNode(true); }));
          }
          var label = item.querySelector('[data-siw-fable-cta-label]');
          if (label) label.textContent = currentStep === 1 ? (planner ? 'NEXT: STICKERS' : 'ADD PLANNER TO BUNDLE')
            : currentStep === 2 ? (minAccessories === 0 ? 'VIEW ACCESSORIES' : 'TO ACCESSORIES') : 'ADD TO CART';
          var prices=item.querySelector('[data-siw-fable-cta-prices]');
          if (prices) prices.hidden = !pricePreviewActive;
          if (pricePreviewActive) {
            var original=item.querySelector('[data-siw-fable-original]'); if (original) original.textContent=formatPrice(subtotal);
            var projected=item.querySelector('[data-siw-fable-estimated]'); if (projected) projected.textContent=formatPrice(estimatedTotal);
          }
          var cta=item.querySelector('[data-siw-fable-cta]');
          if (cta) cta.disabled = busy || cartAdded || (currentStep === 1 && !planner) || (currentStep === 2 && (!planner || stickerQty < 1)) || (currentStep === 3 && !kitReady());
        });
      }
      function removeKitEntry(step, variantId) {
        if (busy || cartAdded) return false;
        variantId = String(variantId);
        if (step === 1) {
          if (!planner || String(planner.variantId) !== variantId) return false;
          planner = null;
          if (plannerAdvanceTimer) {
            window.clearTimeout(plannerAdvanceTimer);
            plannerAdvanceTimer = null;
          }
          // Also discard any old, now-incompatible matched clear cover.
          syncClearCoverMatch();
        } else if (step === 2) {
          if (!stickers.delete(variantId)) return false;
        } else if (step === 3) {
          if (!accessories.delete(variantId)) return false;
        } else return false;
        render(); // Recalculate tiers, item counts, subtotal, gift and saved kit.
        return true;
      }
      function renderSlot(slotKey, entries, placeholderText, step) {
        var container = qs('[data-siw-summary-slot="' + slotKey + '"]');
        if (!container) return;
        container.replaceChildren();
        if (!entries.length) {
          var placeholder = document.createElement('p');
          placeholder.className = 'siw__placeholder';
          placeholder.textContent = placeholderText;
          container.appendChild(placeholder);
          return;
        }
        entries.forEach(function (entry) {
          var item = document.createElement('div'); item.className = 'siw__summary-item';
          if (entry.image) {
            var img = document.createElement('img');
            img.className = 'siw__summary-item-image'; img.src = entry.image;
            img.alt = ''; img.loading = 'lazy'; item.appendChild(img);
          } else {
            var imagePlaceholder = document.createElement('span');
            imagePlaceholder.className = 'siw__summary-item-image'; item.appendChild(imagePlaceholder);
          }
          var copy = document.createElement('div'); copy.className = 'siw__summary-item-copy';
          var title = document.createElement('span'); title.className = 'siw__summary-item-name';
          title.textContent = entry.title + (entry.qty > 1 ? ' × ' + entry.qty : ''); copy.appendChild(title);
          if (entry.variantTitle && entry.variantTitle !== 'Default Title') {
            var variant = document.createElement('span'); variant.className = 'siw__summary-item-variant';
            variant.textContent = entry.variantTitle; copy.appendChild(variant);
          }
          var price = document.createElement('span'); price.className = 'siw__summary-item-price';
          price.textContent = formatPrice(entry.price * entry.qty); copy.appendChild(price);
          item.appendChild(copy);
          var remove = document.createElement('button'); remove.type = 'button';
          remove.className = 'siw__remove'; remove.textContent = '×';
          remove.setAttribute('aria-label', 'Remove ' + entry.title);
          remove.addEventListener('click', function () {
            removeKitEntry(step, entry.variantId);
          });
          item.appendChild(remove); container.appendChild(item);
        });
      }
      function render() {
        var stickerQty = totalQuantity(stickers);
        var accessoryQty = totalQuantity(accessories);
        var readyMessage = qs('[data-siw-ready-message]');
        if (readyMessage) {
          var ready = !!planner && stickerQty >= 1;
          var readyTitle = qs('[data-siw-ready-title]');
          if (readyTitle) readyTitle.textContent = ready ? 'Your kit is ready!' : 'Finish building your kit';
          readyMessage.textContent = !ready
            ? 'Choose a planner and at least one sticker packet to complete the essentials. Accessories are optional.'
            : matchedCoverVariantId
              ? 'We matched a clear cover to your planner below. Add it if you like, or add your kit to cart without any extras.'
              : 'Add any accessories you like, or add your kit to cart without any extras.';
        }
        var all = (planner ? [planner] : []).concat(Array.from(stickers.values()), Array.from(accessories.values()));
        var subtotal = all.reduce(function (sum, entry) { return sum + entry.price * entry.qty; }, 0);
        var itemCount = all.reduce(function (sum, entry) { return sum + entry.qty; }, 0);
        var done = completed();
        // When extras are optional, only the two essentials count toward
        // completion. The Step 3 checkmark still appears if extras are chosen.
        var requiredSteps = minAccessories === 0 ? 2 : 3;
        var doneCount = done.slice(0, requiredSteps).filter(Boolean).length;
        var percentage = Math.round(doneCount * 100 / requiredSteps);
        qsa('[data-siw-step-content="' + currentStep + '"] [data-siw-product]').forEach(function (card) {
          if (card.closest('[data-siw-panel]') && card.closest('[data-siw-panel]').hidden) return;
          var step = Number(card.dataset.step);
          var entry = getActiveEntry(card);
          var anyPlannerSelected = step === 1 && planner && planner.productId === card.dataset.productId;
          var selected = !!entry || !!anyPlannerSelected;
          var button = card.querySelector('[data-siw-choose]');
          var label = card.querySelector('[data-siw-choose-text]');
          var selection = selectionFromCard(card);
          card.classList.toggle('is-selected', selected);
          refreshOptionUI(card);
          if (button) {
            button.hidden = step !== 1 && !!entry;
            button.disabled = busy || !selection || (step === 2 && !entry && stickerQty >= maxStickers) || (step === 3 && !entry && accessoryQty >= maxAccessories);
          }
          if (label) {
            var fullChooseCopy = !selection && isClearCoverCard(card) ? 'Unavailable for this planner' :
              step === 1 ? 'Add planner to bundle' : step === 2 ? 'Add set to bundle' : 'Add to bundle';
            // Keep full, specific button copy on desktop and for assistive tech
            // while making Step 1 and Step 2 buttons concise on mobile.
            // CSS handles responsive visibility, including after viewport resize.
            if ((step === 1 || step === 2) && selection) {
              var longCopy = document.createElement('span');
              longCopy.className = 'siw__choose-label-desktop';
              longCopy.textContent = fullChooseCopy;
              var shortCopy = document.createElement('span');
              shortCopy.className = 'siw__choose-label-mobile';
              shortCopy.textContent = 'Add to bundle';
              label.replaceChildren(longCopy, shortCopy);
            } else {
              label.textContent = fullChooseCopy;
            }
          }
          var controls = card.querySelector('[data-siw-quantity]');
          if (controls) {
            controls.hidden = !entry;
            var output = controls.querySelector('[data-siw-qty]'); if (output) output.textContent = entry ? entry.qty : '0';
            var increase = controls.querySelector('[data-siw-increase]');
            if (increase) increase.disabled = busy || (step === 2 ? stickerQty >= maxStickers : accessoryQty >= maxAccessories);
            var decrease = controls.querySelector('[data-siw-decrease]'); if (decrease) decrease.disabled = busy;
          }
        });
        // If the shopper manually changes the recommended clear cover size, don't
        // continue labeling the different selection as a verified size match.
        var coverMatchIsSelected = false;
        coverMatchIsSelected = !!matchedCoverVariantId;
        var coverNotice = qs('[data-siw-cover-notice]');
        if (coverNotice) coverNotice.hidden = !coverMatchIsSelected;
        var addedNotice = qs('[data-siw-added-notice]');
        if (itemCount > 0) showAddedNotice = false;
        if (addedNotice) addedNotice.hidden = !showAddedNotice;
        renderSlot('planner', planner ? [planner] : [], 'Your planner will appear here', 1);
        renderSlot('sticker', Array.from(stickers.values()), 'Your sticker sets will appear here', 2);
        renderSlot('accessory', Array.from(accessories.values()), minAccessories ? 'Choose at least ' + minAccessories + ' accessory item(s)' : 'Optional finishing touches', 3);
        qs('[data-siw-sticker-count]').textContent = stickerQty ? stickerQty + ' selected' : '';
        qs('[data-siw-accessory-count]').textContent = accessoryQty ? accessoryQty + ' selected' : '';
        qs('[data-siw-total]').textContent = formatPrice(subtotal);
        // Savings require BOTH a planner and at least one sticker set. Adding
        // only the planner does not fill the meter or show a discounted price.
        // Count total sticker SET quantity (including multiples of one variant).
        // The visual estimate does NOT apply or guarantee a Shopify cart discount.
        var reachedTier = !planner || stickerQty < 1 ? 0 : stickerQty >= 3 ? 3 : stickerQty >= 2 ? 2 : 1;
        if (lastTier === null) lastTier = reachedTier;
        else if (reachedTier !== lastTier) {
          if (reachedTier > lastTier) siwTrack('tier_reached', { tier: reachedTier, offer_percent: discountTiers[reachedTier - 1], sticker_qty: stickerQty });
          lastTier = reachedTier;
        }
        var discountPercent = reachedTier ? discountTiers[reachedTier - 1] : 0;
        var progressWidth = reachedTier >= 3 ? '100%' : reachedTier === 2 ? '50%' : reachedTier === 1 ? '24%' : '0%';
        qsa('[data-siw-reward-fill]').forEach(function (fill) { fill.style.width = progressWidth; });
        qsa('[data-siw-tier-step]').forEach(function (dot) {
          dot.classList.toggle('is-reached', reachedTier >= Number(dot.dataset.siwTierStep));
        });
        var rewardMessage = savingsMessage(stickerQty, reachedTier);
        if (!showSavings && siwCopy.previewPrefix) rewardMessage = siwCopy.previewPrefix + ' ' + rewardMessage;
        qsa('[data-siw-reward-message]').forEach(function (element) { element.textContent = rewardMessage; });
        // Price previews begin only when the first sticker set joins the planner;
        // kitReady() still governs the final Add to Cart action.
        var hasEstimate = showSavings && reachedTier > 0;
        var discountAmount = hasEstimate ? Math.round(subtotal * discountPercent / 100) : 0;
        qs('[data-siw-savings]').hidden = !hasEstimate;
        if (hasEstimate) {
          qs('[data-siw-discount-rate]').textContent = String(discountPercent);
          qs('[data-siw-discount-amount]').textContent = '−' + formatPrice(discountAmount);
          qs('[data-siw-estimated-total]').textContent = formatPrice(subtotal - discountAmount);
        }
        var finalEstimate = subtotal - discountAmount;
        var pricePreviewActive = showPricePreview && hasEstimate;
        var giftUnlocked = giftMode && reachedTier === 3 && giftReady;
        var giftSlot = qs('[data-siw-gift-slot]');
        if (giftSlot) giftSlot.hidden = !giftUnlocked;
        var barItems = giftUnlocked ? all.concat([{
          title: 'FREE GIFT · ' + gift.title, image: gift.image, variantTitle: gift.variantTitle, qty: 1, isFreeGift: true
        }]) : all;
        renderFableBar(barItems, subtotal, finalEstimate, discountPercent, reachedTier, stickerQty, pricePreviewActive);
        var originalSticky = qs('[data-siw-mobile-original]');
        var estimatedSticky = qs('[data-siw-mobile-estimate-label]');
        originalSticky.hidden = !pricePreviewActive;
        estimatedSticky.hidden = !pricePreviewActive;
        if (pricePreviewActive) originalSticky.textContent = formatPrice(subtotal);
        qs('[data-siw-mobile-total]').textContent = formatPrice(finalEstimate);
        var checkoutPrices = qs('[data-siw-checkout-prices]');
        checkoutPrices.hidden = !pricePreviewActive;
        if (pricePreviewActive) {
          qs('[data-siw-checkout-original]').textContent = formatPrice(subtotal);
          qs('[data-siw-checkout-estimated]').textContent = 'Est. ' + formatPrice(finalEstimate);
        }
        var displayedCount = itemCount + (giftUnlocked ? 1 : 0);
        qs('[data-siw-sticky-count]').textContent = displayedCount + (displayedCount === 1 ? ' item' : ' items');
        qs('[data-siw-count]').textContent = minAccessories === 0
          ? doneCount + ' of 2 essentials selected' : doneCount + ' of 3 steps complete';
        qs('[data-siw-progress-text]').textContent = percentage + '%';
        qs('[data-siw-progress-bar]').style.width = percentage + '%';
        qsa('[data-siw-go-step]').forEach(function (button) {
          var index = Number(button.dataset.siwGoStep);
          button.classList.toggle('is-current', index === currentStep);
          button.classList.toggle('is-complete', !!done[index - 1] && index !== currentStep);
          if (index === currentStep) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        qs('[data-siw-add-to-cart]').disabled = busy || cartAdded || !kitReady();
        var stickyButton = qs('[data-siw-mobile-next]');
        qs('[data-siw-sticky-action]').textContent = currentStep === 1 ? (planner ? 'Continue to stickers →' : 'Choose a planner')
          : currentStep === 2 ? (minAccessories === 0 ? 'View accessories →' : 'Continue to accessories →')
          : (minAccessories === 0 && accessoryQty === 0 ? 'Skip extras & add to cart →' : 'Add kit to cart →');
        var stickyPrices = qs('[data-siw-sticky-prices]');
        stickyPrices.hidden = !pricePreviewActive;
        if (pricePreviewActive) {
          qs('[data-siw-sticky-original]').textContent = formatPrice(subtotal);
          qs('[data-siw-sticky-estimated]').textContent = 'Est. ' + formatPrice(finalEstimate);
        }
        stickyButton.disabled = busy || cartAdded || (currentStep === 1 && !planner) || (currentStep === 2 && (!planner || stickerQty < 1)) || (currentStep === 3 && !kitReady());
        qsa('[data-siw-end-next]').forEach(function (button) {
          var step = Number(button.dataset.siwEndNext);
          var label = button.querySelector('[data-siw-end-next-label]');
          if (label) label.textContent = step === 1 ? (planner ? 'Continue to sticker sets →' : 'Choose your planner')
            : step === 2 ? (minAccessories === 0 ? 'View accessories →' : 'Continue to accessories →')
            : (minAccessories === 0 && accessoryQty === 0 ? 'Skip extras & add kit to cart →' : 'Add kit to cart →');
          button.disabled = busy || cartAdded || (step === 1 && !planner)
            || (step === 2 && (!planner || stickerQty < 1))
            || (step === 3 && !kitReady());
        });
        qs('[data-siw-sticky-back]').hidden = currentStep === 1;
        var helper = !planner ? 'Choose a planner to get started.' : !stickerQty ? 'Choose at least one set.'
          : accessoryQty < minAccessories ? 'Choose at least ' + minAccessories + ' accessory item(s).'
          : minAccessories === 0 && accessoryQty === 0 ? 'Your kit is ready — accessories are optional.' : 'Your welcome kit is ready!';
        if (stickerQty >= maxStickers && currentStep === 2) helper = 'Maximum of ' + maxStickers + ' sets selected.';
        if (accessoryQty >= maxAccessories && currentStep === 3) helper = 'Maximum of ' + maxAccessories + ' accessory items selected.';
        qs('[data-siw-helper]').textContent = helper;
        saveKit();
        scheduleFablePin();
      }
      function savingsMessage(stickerQty, reachedTier) {
        if (giftMode && planner && reachedTier === 2) {
          return 'You’re saving ' + discountTiers[1] + '%! Add 1 more set to unlock ' +
            (giftReady ? 'a free ' + gift.title + '.' : 'the top gift tier.');
        }
        if (giftMode && planner && reachedTier === 3) {
          return giftReady ? 'You’re saving ' + discountTiers[1] + '% + a free ' + gift.title + '!'
            : 'You’re saving ' + discountTiers[1] + '%. The gift is currently unavailable.';
        }
        var key = !planner ? (stickerQty ? 'needPlanner' : 'needBoth')
          : stickerQty === 0 ? 'needSet'
          : reachedTier === 1 ? 'tier1' : reachedTier === 2 ? 'tier2' : 'tier3';
        return siwFmt(siwCopy[key]);
      }
      function currentTier() {
        var qty = totalQuantity(stickers);
        return !planner || qty < 1 ? 0 : qty >= 3 ? 3 : qty >= 2 ? 2 : 1;
      }
      // Snapshot used for analytics events (prices are in cents, like Shopify's cart).
      function kitSnapshot(groupId) {
        var rows = [];
        if (planner) rows.push({ entry: planner, step: 'Planner' });
        stickers.forEach(function (entry) { rows.push({ entry: entry, step: 'Sticker packet' }); });
        accessories.forEach(function (entry) { rows.push({ entry: entry, step: 'Accessories' }); });
        var tier = currentTier();
        return {
          kit_group: groupId || '',
          tier: tier,
          offer_percent: tier ? discountTiers[tier - 1] : 0,
          gift_variant_id: giftReady && tier === 3 ? Number(gift.variantId) : null,
          item_count: rows.reduce(function (sum, row) { return sum + row.entry.qty; }, 0),
          value: rows.reduce(function (sum, row) { return sum + row.entry.price * row.entry.qty; }, 0),
          currency: currency,
          items: rows.map(function (row) {
            return { product_id: row.entry.productId, variant_id: row.entry.variantId, title: row.entry.title,
              variant_title: row.entry.variantTitle, quantity: row.entry.qty, price: row.entry.price, step: row.step };
          })
        };
      }
      // ---- Saved progress (sessionStorage: this tab only, expires after idle time) ----
      var storageKey = 'siw-kit:' + window.location.pathname + ':' + (root.dataset.sectionId || '');
      function readStoredKit() {
        if (!restoreMinutes) return null;
        try {
          var raw = window.sessionStorage.getItem(storageKey);
          if (!raw) return null;
          var data = JSON.parse(raw);
          if (!data || data.version !== 1 || !data.savedAt || Date.now() - data.savedAt > restoreMinutes * 60000) {
            window.sessionStorage.removeItem(storageKey);
            return null;
          }
          return data;
        } catch (storageError) { return null; }
      }
      function clearStoredKit() {
        try { window.sessionStorage.removeItem(storageKey); } catch (storageError) { /* storage can be blocked */ }
      }
      function saveKit() {
        if (!restoreMinutes || restoring) return;
        try {
          if (!planner && !stickers.size && !accessories.size) { window.sessionStorage.removeItem(storageKey); return; }
          var pack = function (entry) { return { productId: entry.productId, variantId: entry.variantId, qty: entry.qty }; };
          window.sessionStorage.setItem(storageKey, JSON.stringify({
            version: 1,
            savedAt: Date.now(),
            planner: planner ? pack(planner) : null,
            stickers: Array.from(stickers.values()).map(pack),
            accessories: Array.from(accessories.values()).map(pack)
          }));
        } catch (storageError) { /* storage can be full or blocked */ }
      }
      function findCard(step, productId) {
        return qsa('[data-step="' + step + '"][data-siw-product]').find(function (card) {
          return String(card.dataset.productId) === String(productId);
        }) || null;
      }
      // Re-selects a saved variant on its card. Variants that are now sold out or gone return null.
      function selectSavedVariant(card, variantId) {
        var select = card && card.querySelector('[data-siw-variant]');
        if (!select) return null;
        if (isClearCoverCard(card)) return selectionFromCard(card);
        var option = Array.from(select.options).find(function (item) {
          return String(item.value) === String(variantId) && !item.disabled;
        });
        if (!option) return null;
        select.value = option.value;
        refreshCardVariant(card);
        return selectionFromCard(card);
      }
      function restoreSavedMap(items, step, map, limit) {
        (items || []).forEach(function (item) {
          var room = limit - totalQuantity(map);
          if (room < 1) return;
          var choice = selectSavedVariant(findCard(step, item.productId), item.variantId);
          if (!choice) return;
          choice.qty = Math.min(Math.max(1, Number(item.qty) || 1), room);
          map.set(choice.variantId, choice);
        });
      }
      function restoreKit() {
        var saved = readStoredKit();
        if (!saved) return false;
        restoring = true;
        try {
          if (saved.planner) {
            var plannerChoice = selectSavedVariant(findCard(1, saved.planner.productId), saved.planner.variantId);
            if (plannerChoice) planner = plannerChoice;
          }
          // The matched clear cover depends on the planner, so sync before restoring accessories.
          syncClearCoverMatch();
          if (saved.stickers && saved.stickers.length) mountStepProducts(2);
          if (saved.accessories && saved.accessories.length) { mountStepProducts(3); syncClearCoverMatch(); }
          restoreSavedMap(saved.stickers, 2, stickers, maxStickers);
          restoreSavedMap(saved.accessories, 3, accessories, maxAccessories);
        } finally {
          restoring = false;
        }
        return !!(planner || stickers.size || accessories.size);
      }
      // ---- Step history (#kit-step-N) so the browser Back button moves between steps ----
      function stepFromHash() {
        var match = /^#kit-step-([1-3])$/.exec(window.location.hash || '');
        return match ? Number(match[1]) : 0;
      }
      function stepAllowed(step) {
        return step === 1 || (step === 2 && !!planner) || (step === 3 && !!planner && totalQuantity(stickers) >= 1);
      }
      function writeStepHistory(step, mode) {
        if (mode === 'none' || !window.history) return;
        var base = window.location.pathname + window.location.search;
        var target = step === 1 ? base : base + '#kit-step-' + step;
        try {
          if (mode === 'push') {
            if (stepFromHash() === (step === 1 ? 0 : step)) return;
            window.history.pushState(Object.assign({}, window.history.state || {}, { siwStep: step }), '', target);
          } else {
            window.history.replaceState(Object.assign({}, window.history.state || {}, { siwStep: step }), '', target);
          }
        } catch (historyError) { /* history can be restricted in some embeds */ }
      }
      // After a successful add the kit is in Shopify's cart, so start fresh.
      function resetKitAfterAdd() {
        if (plannerAdvanceTimer) { window.clearTimeout(plannerAdvanceTimer); plannerAdvanceTimer = null; }
        planner = null;
        stickers.clear();
        accessories.clear();
        syncClearCoverMatch();
        currentStep = 1;
        qsa('[data-siw-step-content]').forEach(function (panel) { panel.hidden = Number(panel.dataset.siwStepContent) !== 1; });
        toggleFableDrawer(false);
        writeStepHistory(1, 'replace');
        clearStoredKit();
        lastTier = 0;
        showAddedNotice = true;
      }
      // Best-effort cart attributes so orders can be identified as builder orders.
      // Line item properties remain the source of truth; this never blocks the shopper.
      async function tagCartForKit(base, groupId) {
        try {
          var cartResponse = await fetch(base + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
          var cartData = cartResponse.ok ? await cartResponse.json() : {};
          var groups = String((cartData.attributes && cartData.attributes._siw_kit_groups) || '').split(',').filter(Boolean);
          if (groups.indexOf(groupId) === -1) groups.push(groupId);
          await fetch(base + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: {
              '_siw_builder': 'welcome-kit',
              '_siw_builder_version': siwVersion,
              '_siw_kit_count': String(groups.length),
              '_siw_kit_groups': groups.join(',')
            } })
          });
        } catch (tagError) { /* attribution is optional */ }
      }
      function showStep(step, options) {
        options = options || {};
        if (step < 1 || step > 3 || busy) return;
        if (plannerAdvanceTimer) { window.clearTimeout(plannerAdvanceTimer); plannerAdvanceTimer = null; }
        var changed = step !== currentStep;
        currentStep = step;
        if (step === 3) { mountStepProducts(3); syncClearCoverMatch(); }
        if (step === 2) mountStepProducts(2);
        qsa('[data-siw-step-content]').forEach(function (panel) { panel.hidden = Number(panel.dataset.siwStepContent) !== step; });
        render();
        writeStepHistory(step, options.history || 'push');
        if (changed) siwTrack('step_viewed', { step: step });
        if (options.silent) return;
        var catalog = qs('.siw__catalog');
        if (catalog) {
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          catalog.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
        // Announce the new step for keyboard/screen-reader users without shifting the viewport.
        var stepTitle = qs('[data-siw-step-content="' + step + '"] h2');
        if (stepTitle) {
          try { stepTitle.focus({ preventScroll: true }); } catch (error) { stepTitle.focus(); }
        }
      }
      var tabDescriptions = {};
      try { tabDescriptions = JSON.parse((root.querySelector('[data-siw-tab-descriptions]') || {}).textContent || '{}'); }
      catch (error) { tabDescriptions = {}; }
      function showTab(key) {
        var step = Number(key.split('-')[0]);
        var content = qs('[data-siw-step-content="' + step + '"]');
        if (!content) return;
        content.querySelectorAll('[data-siw-tab]').forEach(function (tab) {
          var active = tab.dataset.siwTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        content.querySelectorAll('[data-siw-panel]').forEach(function (panel) { panel.hidden = panel.dataset.siwPanel !== key; });
        var guidance = content.querySelector('[data-siw-tab-guidance]');
        if (guidance) guidance.textContent = tabDescriptions[key.slice(2)] || '';
        render();
      }
      async function addToCart() {
        if (busy || cartAdded) return;
        // Revalidate at submission so a stale cover size cannot enter the cart.
        syncClearCoverMatch();
        if (!kitReady()) { render(); return; }
        busy = true; render();
        var errorElement = qs('[data-siw-error]');
        errorElement.hidden = true; errorElement.textContent = '';
        var groupId = 'SI-WELCOME-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        var lines = [{ selection: planner, step: 'Planner' }]
          .concat(Array.from(stickers.values()).map(function (entry) { return { selection: entry, step: 'Sticker packet' }; }))
          .concat(Array.from(accessories.values()).map(function (entry) { return { selection: entry, step: 'Accessories' }; }));
        // Snapshot BEFORE the add: the builder resets itself after a successful add.
        var kitTier = currentTier();
        var offerPercent = kitTier ? discountTiers[kitTier - 1] : 0;
        var kitSnapshotData = kitSnapshot(groupId);
        var items = lines.map(function (line) {
          // Underscore properties are hidden from shoppers at checkout but stay on the order in Shopify admin.
          return { id: Number(line.selection.variantId), quantity: line.selection.qty,
            properties: {
              '_Sterling Ink Kit': 'Welcome Kit',
              '_Kit Group': groupId,
              '_Kit Step': line.step,
              '_Kit Tier': String(kitTier),
              '_Kit Offer Percent': String(offerPercent),
              '_Kit Version': siwVersion,
              '_Kit Source': 'Welcome Kit Builder'
            } };
        });
        // One additional, merchant-selected gift variant, only after reaching tier 3.
        // The gift is a regular Shopify cart line; an external discount must make it free.
        if (giftReady && kitTier === 3) {
          items.push({ id: Number(gift.variantId), quantity: 1, properties: {
            '_Sterling Ink Kit': 'Welcome Kit',
            '_Kit Group': groupId,
            '_Kit Step': 'Free gift',
            '_Kit Tier': String(kitTier),
            '_Kit Offer Percent': String(offerPercent),
            '_Kit Gift': 'Yes',
            '_Kit Version': siwVersion,
            '_Kit Source': 'Welcome Kit Builder'
          } });
        }
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (base.slice(-1) !== '/') base += '/';
        var giftRetryWithoutGift = false;
        try {
          // A single Ajax call to Shopify preserves variants, quantities, inventory and group properties.
          // Do NOT separately call Rebuy add-to-cart here (that would double-add the products).
          var response = await fetch(base + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          var data = await response.json().catch(function () { return {}; });
          if (!response.ok && giftReady && kitTier === 3 && items.length > 1 &&
              (response.status === 422 || response.status === 400) &&
              /(?:gift|sold out|not available|inventory)/i.test(String(data.description || data.message || ''))) {
            // Shopify's bulk add is atomic on validation failure. Retry once without
            // the optional gift; don't retry network/5xx/ambiguous failures.
            var withoutGift = items.filter(function (item) { return item.properties._Kit_Gift !== 'Yes' && item.properties['_Kit Gift'] !== 'Yes'; });
            response = await fetch(base + 'cart/add.js', {
              method: 'POST', credentials:'same-origin',
              headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
              body:JSON.stringify({ items: withoutGift })
            });
            data = await response.json().catch(function () { return {}; });
            if (response.ok) giftRetryWithoutGift = true;
          }
          if (!response.ok) throw new Error(response.status >= 500
            ? 'Shopify is temporarily unavailable. Please try again shortly.'
            : (typeof data.description === 'string' ? data.description :
               typeof data.message === 'string' ? data.message : 'We could not add your kit. Please check stock and try again.'));
          cartAdded = true;
          qs('[data-siw-mobile-bar]').classList.add('is-hidden');
          // The kit is in the cart now: never restore it (prevents duplicate kits on Back).
          clearStoredKit();
          if (giftRetryWithoutGift) {
            var giftStatus = qs('[data-siw-gift-status]');
            if (giftStatus) {
              giftStatus.textContent = 'Your kit was added, but the free gift is no longer available.';
              giftStatus.hidden = false;
            }
          }
          // Attribution is best-effort and must never delay the cart UI.
          tagCartForKit(base, groupId);
          siwTrack('kit_added', Object.assign({}, kitSnapshotData, { gift_omitted: giftRetryWithoutGift }));
          // Smart Cart watches native Ajax adds. Force a cart sync before showing it so
          // multi-item additions appear together even in themes that don't emit cart events.
          if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function' &&
              window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
            try {
              await Promise.resolve(window.Rebuy.Cart.fetchCart());
              // Start a fresh kit behind the Smart Cart (cartAdded stays true until it closes).
              resetKitAfterAdd();
              window.Rebuy.SmartCart.show();
              busy = false; render(); updateFablePin();
              // Safety net: if Smart Cart never reports that it opened, don't leave the builder locked.
              window.setTimeout(function () {
                if (!rebuyCartOpen && cartAdded) {
                  cartAdded = false;
                  if (bar) bar.classList.remove('is-hidden');
                  render(); updateFablePin();
                }
              }, 1500);
              return;
            } catch (rebuyError) {
              // The items are already in Shopify; never retry the add. Use the native cart.
              window.location.assign(base + 'cart');
              return;
            }
          }
          // If Rebuy isn't present, do not strand shoppers with a seemingly successful button.
          window.location.assign(base + 'cart');
        } catch (error) {
          errorElement.textContent = (error && error.message) || 'We could not add your kit. Please try again.';
          siwTrack('kit_add_failed', { message: String((error && error.message) || 'unknown') });
          errorElement.hidden = false;
          busy = false;
          cartAdded = false;
          qs('[data-siw-mobile-bar]').classList.remove('is-hidden');
          render();
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
      function handleClick(event) {
        var removeThumb = event.target.closest('[data-siw-remove-thumb]');
        if (removeThumb && (fableFixed && fableFixed.contains(removeThumb) || bar && bar.contains(removeThumb))) {
          event.preventDefault();
          event.stopPropagation();
          var thumbContainer = removeThumb.closest('[data-siw-fable-picks], [data-siw-mobile-thumbs]');
          var thumbButtons = thumbContainer ? Array.from(thumbContainer.querySelectorAll('[data-siw-remove-thumb]')) : [];
          var removedIndex = thumbButtons.indexOf(removeThumb);
          if (removeKitEntry(Number(removeThumb.dataset.siwRemoveThumb), removeThumb.dataset.siwVariantId)) {
            // Keep keyboard users in the thumbnail list after the clicked button is rerendered.
            var remaining = thumbContainer ? thumbContainer.querySelectorAll('[data-siw-remove-thumb]') : [];
            var nextFocus = remaining.length ? remaining[Math.min(Math.max(0, removedIndex), remaining.length - 1)] :
              (thumbContainer && thumbContainer.hasAttribute('tabindex') ? thumbContainer : qs('[data-siw-mobile-next]'));
            if (nextFocus && typeof nextFocus.focus === 'function') nextFocus.focus({ preventScroll: true });
          }
          return;
        }
        if (event.target.closest('[data-siw-build-another]')) {
          var giftStatus = qs('[data-siw-gift-status]');
          if (giftStatus) giftStatus.hidden = true;
          showAddedNotice = false;
          showStep(1, { history: 'replace' });
          render();
          return;
        }
        if (event.target.closest('[data-siw-fable-toggle]')) { toggleFableDrawer(!fableDrawerOpen); updateFablePin(); return; }
        if (event.target.closest('[data-siw-fable-close]') || event.target.closest('[data-siw-fable-scrim]')) { toggleFableDrawer(false); updateFablePin(); return; }
        if (event.target.closest('[data-siw-fable-cta]') || event.target.closest('[data-siw-end-next]')) {
          if (currentStep === 1 && planner) showStep(2);
          else if (currentStep === 2 && planner && totalQuantity(stickers) >= 1) showStep(3);
          else if (currentStep === 3 && kitReady()) addToCart();
          return;
        }
        var more = event.target.closest('[data-siw-show-more]');
        if (more && root.contains(more)) {
          var panel = more.closest('[data-siw-panel]');
          if (panel) {
            var batch = Math.max(6, Number(root.dataset.pageSize) || 12);
            Array.from(panel.querySelectorAll('[data-siw-load-more][hidden]')).slice(0, batch).forEach(function (card) {
              card.hidden = false; card.removeAttribute('data-siw-load-more');
            });
            more.hidden = !panel.querySelector('[data-siw-load-more][hidden]');
            render();
          }
          return;
        }
        var tab = event.target.closest('[data-siw-tab]');
        if (tab && root.contains(tab)) { showTab(tab.dataset.siwTab); return; }
        var stepButton = event.target.closest('[data-siw-go-step]');
        if (stepButton && root.contains(stepButton)) { showStep(Number(stepButton.dataset.siwGoStep)); return; }
        var choice = event.target.closest('[data-siw-option]');
        if (choice && root.contains(choice) && !choice.disabled) {
          var card = choice.closest('[data-siw-product]');
          if (isClearCoverCard(card)) return;
          var select = card.querySelector('[data-siw-variant]');
          var index = choice.dataset.siwOptionPosition;
          var value = choice.dataset.siwOptionValue;
          var options = Array.from(select.options).filter(function (option) { return option.value && !option.disabled; });
          var current = select.options[select.selectedIndex];
          var desired = [1, 2, 3].map(function (p) { return current ? current.dataset['option' + p] : ''; });
          desired[Number(index) - 1] = value;
          var exact = options.find(function (option) {
            return [1, 2, 3].every(function (p) { return (option.dataset['option' + p] || '') === (desired[p - 1] || ''); });
          });
          var replacement = exact || options.find(function (option) { return option.dataset['option' + index] === value; });
          if (replacement) {
            select.value = replacement.value;
            refreshCardVariant(card);
            // Editing the variant of the already-chosen planner updates the kit.
            // Editing a different product's swatches does not silently choose it.
            if (Number(card.dataset.step) === 1 && planner && planner.productId === card.dataset.productId) {
              planner = selectionFromCard(card);
              syncClearCoverMatch();
            }
            render();
          }
          return;
        }
        var chooseButton = event.target.closest('[data-siw-choose]');
        if (chooseButton && root.contains(chooseButton) && !chooseButton.disabled) {
          updateQuantity(chooseButton.closest('[data-siw-product]'), 1); return;
        }
        var plus = event.target.closest('[data-siw-increase]');
        if (plus && root.contains(plus) && !plus.disabled) { updateQuantity(plus.closest('[data-siw-product]'), 1); return; }
        var minus = event.target.closest('[data-siw-decrease]');
        if (minus && root.contains(minus) && !minus.disabled) { updateQuantity(minus.closest('[data-siw-product]'), -1); return; }
        if (event.target.closest('[data-siw-sticky-back]')) { showStep(currentStep - 1); return; }
        if (event.target.closest('[data-siw-mobile-next]')) {
          if (currentStep === 1 && planner) showStep(2);
          else if (currentStep === 2 && planner && totalQuantity(stickers) >= 1) showStep(3);
          else if (currentStep === 3 && kitReady()) addToCart();
          return;
        }
        if (event.target.closest('[data-siw-add-to-cart]')) addToCart();
      }
      root.addEventListener('click', handleClick, { signal: signal });
      if (bar) bar.addEventListener('click', handleClick, { signal: signal });
      if (fableFixed) fableFixed.addEventListener('click', handleClick, { signal: signal });
      // Dialog lives inside the section; click events bubble to root.

      window.addEventListener('scroll', scheduleFablePin, { passive:true, signal:signal });
      window.addEventListener('resize', function () {
        cachedTopSetting = parseFloat(getComputedStyle(root).getPropertyValue('--siw-fable-top')) || 0;
        if (fableFixed) cachedFableHeight = fableFixed.getBoundingClientRect().height;
        if (fableAnchor) fableAnchor.style.height = cachedFableHeight + 'px';
        scheduleFablePin();
      }, { passive:true, signal:signal });
      if (fableFixed && 'ResizeObserver' in window) {
        barResizeObserver = new ResizeObserver(function (entries) {
          var height = entries[0].borderBoxSize ?
            (Array.isArray(entries[0].borderBoxSize) ? entries[0].borderBoxSize[0].blockSize : entries[0].borderBoxSize.blockSize) :
            entries[0].contentRect.height;
          if (Math.abs(cachedFableHeight - height) > 1) {
            cachedFableHeight = height;
            if (fableAnchor) fableAnchor.style.height = Math.ceil(height) + 'px';
            scheduleFablePin();
          }
        });
        barResizeObserver.observe(fableFixed);
      }
      // The native dialog closes itself on Esc. Keep button aria-expanded in sync.
      if (fableSummary) {
        fableSummary.addEventListener('close', function () {
          fableDrawerOpen = false;
          fableBars.forEach(function (item) {
            var btn = item.querySelector('[data-siw-fable-toggle]');
            if (btn) btn.setAttribute('aria-expanded','false');
          });
          scheduleFablePin();
        }, { signal:signal });
        fableSummary.addEventListener('click', function (event) {
          if (event.target === fableSummary) toggleFableDrawer(false);
        }, { signal:signal });
      }
      // Browser Back/Forward moves between steps instead of leaving the builder.
      window.addEventListener('popstate', function () {
        var urlStep = stepFromHash() || 1;
        var wanted = urlStep;
        while (wanted > 1 && !stepAllowed(wanted)) wanted--;
        if (wanted !== currentStep || wanted !== urlStep) showStep(wanted, { history: wanted === urlStep ? 'none' : 'replace' });
      }, { signal:signal });
      // Returning via the bfcache after a cart redirect must not show the old kit as still open.
      window.addEventListener('pageshow', function (event) {
        if (event.persisted && cartAdded) {
          resetKitAfterAdd();
          cartAdded = false; busy = false;
          if (bar) bar.classList.remove('is-hidden');
          render(); updateFablePin();
        }
      }, { signal:signal });
      root.addEventListener('change', function (event) {
        var select = event.target.closest('[data-siw-variant]');
        if (!select || !root.contains(select)) return;
        var card = select.closest('[data-siw-product]');
        if (isClearCoverCard(card)) { syncClearCoverMatch(); render(); return; }
        var entry = selectionFromCard(card);
        if (!entry) return;
        refreshCardVariant(card);
        // Existing selections of other variants are deliberately not overwritten.
        render();
      }, { signal:signal });
      root.addEventListener('keydown', function (event) {
        var tab = event.target.closest('[data-siw-tab]');
        if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        var list = Array.from(tab.parentNode.querySelectorAll('[data-siw-tab]'));
        var index = list.indexOf(tab); if (index < 0) return;
        event.preventDefault();
        if (event.key === 'ArrowRight') index = (index + 1) % list.length;
        if (event.key === 'ArrowLeft') index = (index - 1 + list.length) % list.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = list.length - 1;
        showTab(list[index].dataset.siwTab); list[index].focus();
      }, { signal:signal });
      root.addEventListener('shopify:block:select', function (event) {
        var panel = event.target.closest('[data-siw-panel]');
        if (!panel) return;
        var key = panel.dataset.siwPanel;
        showStep(Number(key.split('-')[0]), { history: 'none' });
        showTab(key);
      }, { signal:signal });
      // One "builder viewed" event the first time a quarter of the builder is on screen.
      if ('IntersectionObserver' in window) {
        viewObserver = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && !builderViewedSent) {
            builderViewedSent = true;
            viewObserver.disconnect();
            siwTrack('builder_viewed', {});
          }
        }, { threshold: 0.25 });
        viewObserver.observe(root);
      } else {
        builderViewedSent = true;
        siwTrack('builder_viewed', {});
      }
      // The persistent bar is visible while this section intersects the viewport.
      if (bar && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', entries[0].isIntersecting && !cartAdded);
        }, { threshold: 0 });
        observer.observe(root);
      } else if (bar) bar.classList.add('is-visible');
      // Smart Cart should always win the stacking context over the fixed builder CTA.
      document.addEventListener('rebuy:smartcart.show', function () {
        rebuyCartOpen = true;
        if (bar) bar.classList.add('is-hidden');
        if (fableFixed) fableFixed.classList.add('is-hidden');
        toggleFableDrawer(false);
      }, { signal:signal });
      document.addEventListener('rebuy:smartcart.hide', function () {
        rebuyCartOpen = false;
        if (bar && !busy) { cartAdded = false; bar.classList.remove('is-hidden'); }
        updateFablePin();
      }, { signal:signal });
      var restoredKit = restoreKit();
      syncClearCoverMatch();
      var initialStep = stepFromHash();
      while (initialStep > 1 && !stepAllowed(initialStep)) initialStep--;
      if (initialStep > 1) {
        showStep(initialStep, { history: 'replace', silent: true });
      } else {
        if (stepFromHash() > 1) writeStepHistory(1, 'replace');
        render();
      }
      var firstTab = root.querySelector('[data-siw-tab].is-active');
      if (firstTab) {
        var guidance = root.querySelector('[data-siw-tab-guidance]');
        if (guidance) guidance.textContent = tabDescriptions[firstTab.dataset.siwTab.slice(2)] || '';
      }
      scheduleFablePin();
      if (restoredKit) siwTrack('kit_restored', kitSnapshot(''));
      root.siwDestroy = function () {
        controller.abort();
        if (plannerAdvanceTimer) window.clearTimeout(plannerAdvanceTimer);
        if (viewObserver) viewObserver.disconnect();
        if (observer) observer.disconnect();
        if (barResizeObserver) barResizeObserver.disconnect();
        if (fableSummary && fableSummary.open) fableSummary.close();
        if (bar && bar.parentElement === document.body) bar.remove();
        if (fableFixed && fableFixed.parentElement === document.body) fableFixed.remove();
        if (fableAnchor) fableAnchor.style.height = '';
        delete root.dataset.siwReady;
        delete root.siwDestroy;
      };
    }
  };
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-siw-root]')
      ? event.target : event.target.querySelector('[data-siw-root]');
    if (!root) return;
    if (typeof root.siwDestroy === 'function') root.siwDestroy();
    var bar = document.getElementById('siw-fixed-bar-' + root.dataset.sectionId);
    if (bar) bar.remove();
    var fableFixed = document.getElementById('siw-fable-fixed-' + root.dataset.sectionId);
    if (fableFixed) fableFixed.remove();
    var fableDrawer = document.getElementById('siw-fable-drawer-' + root.dataset.sectionId);
    if (fableDrawer) fableDrawer.remove();
  });
  document.addEventListener('shopify:section:load', function (event) { window.SIFableRefBundle.initAll(event.target); });
  document.addEventListener('DOMContentLoaded', function () { window.SIFableRefBundle.initAll(document); });
  window.SIFableRefBundle.initAll(document);
})();
